import dayjs from 'dayjs';
import _ from 'lodash';

export const DateTimeUtils = {
  leftTimeFormatMMSS: (countdown: number): string => {
    const minutes = Math.floor(countdown / 60);
    const seconds = countdown % 60;

    const formattedTime = dayjs().set('minute', minutes).set('second', seconds).format('mm:ss');

    return formattedTime;
  },

  toDateString: (selectedDate: Date): string => {
    const year = selectedDate.getFullYear();
    const month = selectedDate.getMonth() + 1;
    const date = selectedDate.getDate();

    return `${year}-${month >= 10 ? month : '0' + month}-${date >= 10 ? date : '0' + date}`;
  },

  toDateStringYYYYMM: (selectedDate: Date | null): string => {
    if (selectedDate === null) {
      return '';
    }

    const year = selectedDate.getFullYear();
    const month = selectedDate.getMonth() + 1;

    return `${year}-${month >= 10 ? month : '0' + month}`;
  },

  calculateAge: (birthDay: string) => {
    const currentDate = dayjs();
    const birthDateObject = dayjs(birthDay);

    const years = currentDate.diff(birthDateObject, 'year');
    birthDateObject.add(years, 'year');

    return years;
  },

  calculateBetweenCareerDate: (startDate: string, endDate: string) => {
    const startDateObject = dayjs(startDate);
    const endDateObject = dayjs(endDate);

    const years = endDateObject.diff(startDateObject, 'year');
    startDateObject.add(years, 'year');

    const months = endDateObject.diff(startDateObject, 'month');

    const leftMonths = months - 12 * years;

    const formattedDifference = `${years === 0 && leftMonths === 0 ? '재직중' : years > 0 ? `${years}년` : ''} ${
      leftMonths > 0 ? `${leftMonths}개월` : ''
    }`;

    return formattedDifference;
  },

  calculateDaysRemaining: (endDate: string) => {
    if (_.isEmpty(endDate)) {
      return '';
    }
    const currentDate = new Date();
    const targetDate = new Date(endDate);
    const timeDifference = targetDate.getTime() - currentDate.getTime();
    const daysRemaining = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

    return daysRemaining;
  },

  stringToDateType: (dateStr: string, format: string): Date | null => {
    if (_.isEmpty(dateStr)) {
      return null;
    }
    return dayjs(dateStr, format).toDate();
  },

  formatYYYYMMDDDate: (dateStr: string) => {
    if(dateStr === null){
      return null;
    }
    return dayjs(dateStr).format('YYYY-MM-DD');
  }
};
